// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"9c04bcfa","716":"9c04bcfa","720":"34f0bc9b","879":"34f0bc9b"}[chunkId] + ".chunk.css";
};